import { CurrentContent } from '@/libs/utils/tiles'
import { ChannelItem } from '@/types'
import { create } from 'zustand'

// Define the store's state
type FullScreenContentState = {
  currentContent: CurrentContent | CurrentContent[]
  fullScreenChannel: ChannelItem[]
  setCurrentContent: (value: CurrentContent | CurrentContent[]) => void
  setFullScreenChannel: (value: ChannelItem[]) => void
}

// Create the store
export const useFullScreenContentStore = create<FullScreenContentState>(
  (set) => ({
    currentContent: {
      heading: null,
      subheading: null,
      show_badge: true,
      content_description: null,
      badge: '',
      content_url: '',
      content_uid: '',
    },
    fullScreenChannel: [] as ChannelItem[], // initial state
    setCurrentContent: (value) => set({ currentContent: value }),
    setFullScreenChannel: (value) => set({ fullScreenChannel: value }),
  }),
)
